<template>
    <div>
        <headers></headers>
        <div class="isloginTips" v-show="islogin || ismnlogin">
            <img src="@/assets/loading.png" alt="">
            <p>正在登录...</p>
        </div>
        <div>
            <div class="content">
                <img v-show="this.$store.state.realcorrectshow" style="margin-bottom:20px" src="@/assets/banner01.png" alt="">
                <img v-show="!this.$store.state.realcorrectshow" src="@/assets/content.png" alt="">
                <div class="btnbox">
                    <div v-show="!this.$store.state.login && !this.$store.state.mnlogin">
                        <a target="_blank" href="https://login.jrzg84.com/#/user/reg"><div class="button">极速开户</div></a>
                        <div class="button02" @click="handleAllBoxShow">已有账户？马上登录</div>
                    </div>
                </div>
            </div>
        </div>


        <div class="mask" ref="closemask" @click="handlemask" v-show="this.$store.state.accountrealbox || this.$store.state.accountfalsebox"></div>
        <!-- 登录真实账户弹框 -->
        <div class="accountbox" id="keyreal" v-show="this.$store.state.accountrealbox">
            <div class="title">
                <span @click="accountboxclose">x</span>
                <span>登录真实账户</span>
                <span> </span>
            </div>

            <div class="inputbox">
                <input class="user" ref="userbtn" type="text" placeholder="请输入真实账户">
                <input class="pwd"  ref='pwdbtn' type="password" placeholder="请输入真实账户交易密码">
            </div>

            <button :class="{disable: islogin || ismnlogin}" :disabled="islogin || ismnlogin" class="btnlogin" @click="handleLoginBtn">登录</button>
        </div>

        <!-- 登录模拟账户弹框 -->
        <div class="accountbox" id="keymn" v-show="this.$store.state.accountfalsebox">
            <div class="title">
                <span @click="accountboxclose">x</span>
                <span>登录模拟账户</span>
                <span> </span>
            </div>

            <div class="inputbox">
                <input class="user" ref="userbtns" type="text" placeholder="请输入模拟账户">
                <input class="pwd" ref='pwdbtns' type="password" placeholder="请输入模拟账户交易密码">
            </div>

            <button :class="{disable: islogin || ismnlogin}" :disabled="islogin || ismnlogin" class="btnlogin" @click="handleLoginBtnfalse">登录</button>
        </div>

    </div>
</template>

<script>

import Headers from '@/components/header'
import pako from 'pako'
import {login0,sendText0,start,utf8ByteToUnicodeStr,toBytes} from '@/utils/socket2.js';
import axios from 'axios'
import { Message } from 'element-ui';

export default {
    components:{
        Headers,
    },
    name:"login",
    data(){
        return{
            islogin:false,//已登录真实账号没登录模拟账号 用于切换
            ismnlogin:false,//已登录模拟账号没登录真实账号 用于切换

            loginSuccess:false,//真实账号登录跳转判断
            mnloginSuccess:false,//模拟账号登录跳转判断

            valueText:'',
            valueShow:'',
            valueTrea:[],

        }
    },
    methods:{

        // 点击蒙层关闭
        handlemask(){
            this.$store.state.accountrealbox = false
            this.$store.state.accountfalsebox = false
        },

        // 点击真实账户登录按钮
        handleLoginBtn(){
            
            if(this.$refs.userbtn.value == ''){
                this.$toast('账号不能为空')
                return false
            }
            if(this.$refs.pwdbtn.value == ''){
                this.$toast('密码不能为空')
                return false
            }

            this.$store.state.loginUser = this.$refs.userbtn.value
            this.$store.state.loginPwd = this.$refs.pwdbtn.value

            // 存储真实账号密码 连接websocket需要用
            // localStorage.setItem('user',this.$refs.userbtn.value)
            // localStorage.setItem('pwd',this.$refs.pwdbtn.value)

            localStorage.setItem('loginUser',this.$store.state.loginUser)
            localStorage.setItem('loginPwd',this.$store.state.loginPwd)

            localStorage.setItem('arglogin',this.$refs.userbtn.value)

            this.islogin = true //点击了真实账户开关为真

            this.localSockets()

        },

        //点击模拟账户登录按钮
        handleLoginBtnfalse(){
            if(this.$refs.userbtns.value == ''){
                this.$toast('账号不能为空')
                return false
            }
            if(this.$refs.pwdbtns.value == ''){
                this.$toast('密码不能为空')
                return false
            }

            this.$store.state.mnloginUser = this.$refs.userbtns.value
            this.$store.state.mnloginPwd = this.$refs.pwdbtns.value


            // 存储模拟账号密码 连接websocket需要用
            // localStorage.setItem('users',this.$refs.userbtns.value)
            // localStorage.setItem('pwds',this.$refs.pwdbtns.value)

            localStorage.setItem('mnloginUser',this.$store.state.mnloginUser)
            localStorage.setItem('mnloginPwd',this.$store.state.mnloginPwd)

            localStorage.setItem('arglogin',this.$refs.userbtns.value)

            this.ismnlogin = true //点击了模拟账户开关为真

            this.localSockets()

        },

        // 点击x关闭登录框
      accountboxclose(){
            this.$store.state.contentshow = true
            this.$store.state.accountrealbox = false
            this.$store.state.accountfalsebox = false
      },

        // 点击已有账户弹出所有账户选择
        handleAllBoxShow(){

            if(this.$store.state.realcorrectshow){
                this.$store.state.contentshow = false //蒙层开启
                this.$store.state.accountrealbox = true //真实账户弹窗
            }else if(!this.$store.state.realcorrectshow){
                this.$store.state.contentshow = false //蒙层开启
                this.$store.state.accountfalsebox = true
            }
    

        },

        localSockets() {

            let that = this

            if ('WebSocket' in window) { 

            var wsImpl = window.WebSocket || window.MozWebSocket;

            if(that.islogin ){ //上面点击了真实账户按钮 这个就为真代表即将登录真实账户接口

                if(localStorage.getItem('loginUser').slice(0,2) == '20'){
                    that.ws = new wsImpl(that.$store.state.ws20); //创建一条websocket
                    that.global.setWs(that.ws) //保存到全局


                }else if(localStorage.getItem('loginUser').slice(0,2) == '30'){
                    that.ws = new wsImpl(that.$store.state.ws30); //创建一条websocket
                    that.global.setWs(that.ws) //保存到全局

  
                }else if(localStorage.getItem('loginUser').slice(0,2) == '51'){
                    that.ws = new wsImpl(that.$store.state.ws51); //创建一条websocket
                    that.global.setWs(that.ws) //保存到全局

 
                }else if(localStorage.getItem('loginUser').slice(0,2) == '11'){
                    that.ws = new wsImpl(that.$store.state.ws20); //创建一条websocket
                    that.global.setWs(that.ws) //保存到全局


                }else if(localStorage.getItem('loginUser').slice(0,2) == '70'){
                    that.ws = new wsImpl(that.$store.state.ws70); //创建一条websocket
                    that.global.setWs(that.ws) //保存到全局

  
                }else{
                    that.$toast('账户或密码有误')
                    that.islogin = false //乱输密码的时候重置
                    return false;
                }

            }

            if(that.ismnlogin){ //上面点击了模拟账户按钮 这个就为真代表即将登录模拟账户接口

                that.ws = new wsImpl(that.$store.state.mnws); //创建一条websocket
                that.global.setWs(that.ws) //保存到全局



            }

                if(that.$store.state.login){

                    if(localStorage.getItem('loginUser').slice(0,2) == '20'){
                        that.ws = new wsImpl(that.$store.state.ws20); //创建一条websocket
                        that.global.setWs(that.ws) //保存到全局

  
                    }else if(localStorage.getItem('loginUser').slice(0,2) == '30'){
                        that.ws = new wsImpl(that.$store.state.ws30); //创建一条websocket
                        that.global.setWs(that.ws) //保存到全局

   
                    }else if(localStorage.getItem('loginUser').slice(0,2) == '51'){
                        that.ws = new wsImpl(that.$store.state.ws51); //创建一条websocket
                        that.global.setWs(that.ws) //保存到全局

       
                    }else if(localStorage.getItem('loginUser').slice(0,2) == '11'){
                        that.ws = new wsImpl(that.$store.state.ws20); //创建一条websocket
                        that.global.setWs(that.ws) //保存到全局

            
                        
                    }else if(localStorage.getItem('loginUser').slice(0,2) == '70'){
                        that.ws = new wsImpl(that.$store.state.ws70); //创建一条websocket
                        that.global.setWs(that.ws) //保存到全局

   
                    }

                }

                if(that.$store.state.mnlogin){
                    that.ws = new wsImpl(that.$store.state.mnws); //创建一条websocket
                    that.global.setWs(that.ws) //保存到全局


                }

            that.ws.onopen = function() {

     
                // 编码用户登录函数发送到websoket
                that.starts() //发送心跳给后端

                if(that.islogin){ //如果是真实账户

                    login0(that.ws,that.$store.state.loginUser,that.$store.state.loginPwd) //发送真实账户请求服务端

                    // localStorage.setItem('loginUser',that.$store.state.loginUser)
                    // localStorage.setItem('loginPwd',that.$store.state.loginPwd)

                }
                
                if(that.ismnlogin){ //如果是模拟账户

                    login0(that.ws,that.$store.state.mnloginUser,that.$store.state.mnloginPwd) //发送模拟账户请求服务端

                    // localStorage.setItem('mnloginUser',that.$store.state.mnloginUser)
                    // localStorage.setItem('mnloginPwd',that.$store.state.mnloginPwd)

                }

                if(that.$store.state.login && that.ws.readyState == 1){
                    login0(that.ws,localStorage.getItem('loginUser'),localStorage.getItem('loginPwd')) //发送真实账户请求服务端
                }

                if(that.$store.state.mnlogin && that.ws.readyState == 1){
                    login0(that.ws,localStorage.getItem('mnloginUser'),localStorage.getItem('mnloginPwd')) //发送模拟账户请求服务端

                }

            }

            that.ws.onmessage = function(evt){
                var data = atob(evt.data);
                var data2 = pako.inflateRaw(data);
                var arr = new Uint16Array(data2);
                var strData   = utf8ByteToUnicodeStr(arr);

                var obj = JSON.parse(strData)

                if(obj.mt){//判断是否MT5
                    that.$store.state.mt = obj.mt
                }else{
                    that.$store.state.mt = null
                }
                    //   登录之后的操作
                    if(that.islogin){ //已经发送了登录请求，真实账户返回数据
                        if(obj.act == 'login_pro' && obj.success){

                            // if(obj.success == true){

                                that.islogin = false

                                that.$store.state.login = true //真实账户登录状态保存到vuex

                                that.$store.state.mnlogin = false //模拟账户状态在vuex关闭

                                that.$store.state.realcorrectshow = true //登录真实账号对应头部导航

                                that.$store.state.realcorrectshow = true //控制图标

                                that.$store.state.mncorrectshow = false //控制图标

                                that.loginSuccess = true //用于监听登录成功时跳转

                                sessionStorage.removeItem("store") //刷新之后如果是模拟账户状态，真实账户为false(清除，等刷新之前会重新获取当前登录状态)
                                sessionStorage.removeItem("mnstore") //刷新之后如果是真实账户，模拟账户变false(清除，等刷新之前会重新获取当前登录状态)

                            // }
                
                        }else{
                            that.$toast(obj.msg); //登陆失败 给提示
                            that.islogin = false //登录失败时 开关重置
                        }

                        that.$store.state.goldindex = true //由于切换账户之前如果客户停留在白银页面，切换之后会刷新页面所以要变为黄金页面true

                    }else if(that.ismnlogin){ //登录模拟账户
                        if(obj.act == 'login_pro' && obj.success){

                            // if(obj.success){

                                that.ismnlogin = false 

                                that.$store.state.mnlogin = true //模拟账号登录状态保存到vuex

                                that.$store.state.login = false //真实账号在vuex的状态关闭

                                that.$store.state.realcorrectshow = false //登录模拟账号对应头部导航

                                that.$store.state.mncorrectshow = true //控制图标

                                that.$store.state.realcorrectshow = false //控制图标

                                that.mnloginSuccess = true //用于监听登录成功时跳转

                                sessionStorage.removeItem("store") //刷新之后如果是模拟账户状态，真实账户为false(清除，等刷新之前会重新获取当前登录状态)
                                sessionStorage.removeItem("mnstore") //刷新之后如果是真实账户，模拟账户变false(清除，等刷新之前会重新获取当前登录状态)
                                
                            // }

                        }else{
                            that.$toast(obj.msg); //登陆失败 给提示
                            that.ismnlogin = false //登录失败时 开关重置
                        }

                        that.$store.state.goldindex = true //由于切换账户之前如果客户停留在白银页面，切换之后会刷新页面所以要变为黄金页面true

                    }

                    if(that.ismnlogin || that.islogin){
                        that.$store.state.contentshow = true //进入登录状态后蒙层关闭
                        that.$store.state.accountrealbox = false //进入登录状态后真实账号登录弹框关闭
                        that.$store.state.accountfalsebox = false //模拟账号弹窗关闭
                    }

            }

            that.global.ws.onclose = function() {
                // 关闭 websocket

                setTimeout(() => {

                    if(that.global.ws){
                        that.global.ws = null
                    }

                    that.localSockets()

                }, 2000)
            }

            }else {
                // 浏览器不支持 WebSocket
                alert('您的浏览器不支持 WebSocket!')
                that.islogin = false
                that.ismnlogin = false
            }

        },

        //在onopen开始之后直接进行f方法调用 数据数据发送
        starts() {　　　　// 发送心跳
            clearInterval(this.timeoutObj)
            this.timeoutObj = setInterval(() => {
                let that = this;
                let date = new Date()        
                if (that.global.ws && that.global.ws.readyState == 1) {

                    that.global.ws.send(`发送心跳给后端${date}`);
                }
            }, 2 * 60 * 1000)
        },



    },

    mounted(){

        this.$store.state.login = false //手机端退出后台再回来，头部信息残留清楚 清除vuex的登录状态
        this.$store.state.mnlogin = false //手机端退出后台再回来，头部信息残留清楚 清除vuex的登录状态
        sessionStorage.removeItem("store") //清空登录状态
        sessionStorage.removeItem("mnstore") //清空登录状态

        this.handleAllBoxShow()

        this.$refs.closemask.style.backgroundColor = "rgba(0,0,0,0.5)"

        this.$store.state.chicanglength = null //清空持仓角标数量

        this.$store.state.guadanlength = null //清空挂单角标数量

        this.$store.state.payment = null //清空可用预付款
        

        var ishttps = 'https:' == document.location.protocol ? true : false;
        function setupWebViewJavascriptBridge(callback) {
            if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
            if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
            window.WVJBCallbacks = [callback];
            var WVJBIframe = document.createElement('iframe');
            WVJBIframe.style.display = 'none';
            WVJBIframe.src = 'https://__bridge_loaded__';
            document.documentElement.appendChild(WVJBIframe);
            setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
        }

        setupWebViewJavascriptBridge(function(bridge) {

            // 获取距离顶部高度
            bridge.registerHandler('JrCall_set', function(data, responseCallback) {
                var bounceKey = data['bounceKey'];
                if(bounceKey){
                    document.getElementById("keyreal").style.bottom = `${bounceKey}px`
                    document.getElementById("keymn").style.bottom = `${bounceKey}px`
                }
            })

        });

    },

    watch:{

        'loginSuccess'(val){
            if(val){
                this.$refs.closemask.style.backgroundColor = "rgba(0,0,0,0.5)"
                this.$toast('已登录真实账户');
                this.$router.push({path:'/deal'})
            }
        },
        'mnloginSuccess'(val){
            if(val){
                this.$refs.closemask.style.backgroundColor = "rgba(0,0,0,0.5)"
                this.$toast('已登录模拟账户');
                this.$router.push({path:'/deal'})
            }
        },
    },

}
</script>

<style scoped>
    body{background-color: #F5F5F5;touch-action: none;}
    .mask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 887;}
    .isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 30%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
    .isloginTips img{width: 40px;height: 40px;display: block;margin-top: 30px;animation:loading 0.75s linear infinite forwards;}
    .content{position: absolute;z-index: 1;top: 91.67px;left: 0;right: 0;margin: 0 auto;}
    .content img{width: 300px;height: 406.67px;margin: 0 auto;display: block;}
    .btnbox{margin-bottom: 68.67px;margin-top: 10px;}
    .button{width: 300px;height: 44px;margin: 0 auto;border-radius: 22px;background-image: linear-gradient(to bottom right, #FF6738, #FF4F36);color: #FFFFFF;font-size: 16px;display: flex;justify-content: center;align-items: center;}
    .button02{width: 300px;height: 44px;margin: 0 auto;border-radius: 22px;border: 1px solid #DDDDDD;margin-top: 15px;color: #333333;font-size: 16px;display: flex;justify-content: center;align-items: center;}
    .btntrue{width: 300px;height: 44px;margin: 0 auto;border-radius: 22px;background-image: linear-gradient(to bottom right, #FF6738, #FF4F36);color: #FFFFFF;font-size: 16px;display: flex;justify-content: center;align-items: center;}
    .btnfalse{width: 300px;height: 44px;margin: 0 auto;border-radius: 22px;background-image: linear-gradient(to bottom right, #FF6738, #FF4F36);color: #FFFFFF;font-size: 16px;display: flex;justify-content: center;align-items: center;}

    .accountbox{background-color: #FFFFFF;border-top-left-radius: 12px;border-top-right-radius: 12px; position: fixed;left: 0;right: 0;bottom: 0;margin: 0 auto;z-index: 888;}
    .accountbox .title{display: flex;justify-content: space-between;align-items: center;padding: 17.67px 16px 10px 20px;}
    .accountbox .title span:nth-of-type(1){width: 14.3px;height: 14.3px;display: block;}
    .accountbox .title span:nth-of-type(2){color: #323232;font-size: 16px;font-weight: bold;}
    .accountbox .title span:nth-of-type(3){color: #FF4F36;font-size: 14px;}

    .accountbox .inputbox{display: flex;flex-direction: column;padding: 15px 15px;}
    .accountbox .inputbox input{width: 100%;height: 50px;border-radius: 12px;background-color: #F8F8F8;color: #BBBBBB;font-size: 16px;font-weight: bold;padding-left: 14.67px;line-height: 50px;border: 0;outline: none;width: 100%;box-sizing: border-box;}
    .accountbox .inputbox .pwd{margin-top: 10px;}
    .accountbox .btnlogin{height: 44px;border-radius: 22px;margin: 0 15px auto;display: flex;justify-content: center;align-items: center;background-color: #FF4F36;color: #FFFFFF;font-size: 16px;font-weight: bold;width: 90%;margin-bottom: 50px;border: none;}

    .disable{background-color: #BBBBBB !important;}


    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }


</style>



// WEBPACK FOOTER //
// src/pages/login.vue